import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';
import { Dropdown } from 'flowbite';

@Component({
  selector: 'app-lang-btn',
  templateUrl: './lang-btn.component.html',
  styleUrls: ['./lang-btn.component.scss'],
  standalone: true,
  imports: [CommonModule, NgxTolgeeModule]
})
export class LangBtnComponent implements OnInit {
  @ViewChild('langBtn') langBtn!: ElementRef;
  @ViewChild('lang') lang!: ElementRef;
  langDropdown!: Dropdown;
  
  close() {
    this.langDropdown.hide()
  }

  ngOnInit(): void {
      
  }

  ngAfterViewInit() {
    this.langDropdown = new Dropdown(this.lang.nativeElement, this.langBtn.nativeElement);
  }

  constructor(public translateService: TranslateService) { }
}
